import { useMemo, useState } from "react";
import { useEvents } from "@/hooks/useEvents";
import AddEventDialog from "@/components/events/AddEventDialog";
import { EventFilterSidebar, type EventFilters } from "@/components/events/EventFilterSidebar";
import EventIntelligenceTable from "@/components/events/EventIntelligenceTable";

const DEFAULT_FILTERS: EventFilters = { search: "", eventType: [], status: [], tier: [], category: [], territory: [] };

const EventIntelligence = () => {
  const { data: events = [], isLoading } = useEvents();
  const [filters, setFilters] = useState<EventFilters>(DEFAULT_FILTERS);

  const filtered = useMemo(() => {
    return events
      .filter((e) => {
        if (filters.search) {
          const q = filters.search.toLowerCase();
          const match = e.event_name.toLowerCase().includes(q) ||
            e.location?.toLowerCase().includes(q) ||
            e.city?.toLowerCase().includes(q) ||
            e.organizer?.toLowerCase().includes(q) ||
            e.focus_areas?.some(f => f.toLowerCase().includes(q));
          if (!match) return false;
        }
        if (filters.eventType.length > 0 && !filters.eventType.includes(e.event_type)) return false;
        if (filters.status.length > 0 && !filters.status.includes(e.status)) return false;
        if (filters.tier.length > 0 && (!e.carr_relevance_tier || !filters.tier.includes(e.carr_relevance_tier))) return false;
        if (filters.category.length > 0 && (!e.carr_event_category || !filters.category.includes(e.carr_event_category))) return false;
        if (filters.territory.length > 0 && (!e.territory || !filters.territory.includes(e.territory))) return false;
        return true;
      })
      .sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
  }, [events, filters]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between p-4 border-b">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Event Intelligence</h1>
          <p className="text-sm text-muted-foreground">Track industry events, match accounts, and plan attendance</p>
        </div>
        <AddEventDialog />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <div className="w-72 shrink-0 border-r overflow-y-auto p-4">
          <EventFilterSidebar filters={filters} onFiltersChange={setFilters} totalCount={filtered.length} />
        </div>

        <div className="flex-1 overflow-auto">
          <EventIntelligenceTable events={filtered} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default EventIntelligence;
